"use strict";

exports.__esModule = true;
exports.Panel = Panel;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = require("../../Theme");
var _whenModern = require("../../Theme/UiDesign/whenModern");
var _excluded = ["title", "icon", "onClose", "overlay", "children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var PanelWrapper = _styledComponents["default"].section.withConfig({
  displayName: "Panel__PanelWrapper",
  componentId: "sc-1yri6o7-0"
})(["display:flex;flex:1;flex-direction:column;color:", ";background:", ";border:", ";", ""], (0, _Theme.val)("PanelColor"), (0, _Theme.val)("PanelBackground"), (0, _Theme.val)("PanelBorder"), (0, _whenModern.whenModern)((0, _styledComponents.css)(["border:0;border-radius:12px;background:#ffffff;box-shadow:", ";"], (0, _Theme.val)("CardShadow"))));
var PanelHeader = _styledComponents["default"].header.withConfig({
  displayName: "Panel__PanelHeader",
  componentId: "sc-1yri6o7-1"
})(["display:flex;flex-direction:row;align-items:center;padding:", ";color:", ";background:", ";border-bottom:", ";", ""], (0, _Theme.val)("PanelPadding"), (0, _Theme.val)("PanelHeaderColor"), (0, _Theme.val)("PanelHeaderBackground"), (0, _Theme.val)("PanelHeaderBorder"), (0, _whenModern.whenModern)((0, _styledComponents.css)(["min-height:48px;padding:0 16px;background:#ffffff;border-bottom:1px solid ", ";border-radius:12px 12px 0 0;"], (0, _Theme.val)("borderColor"))));
var PanelTitle = _styledComponents["default"].h4.withConfig({
  displayName: "Panel__PanelTitle",
  componentId: "sc-1yri6o7-2"
})(["padding:0;margin:0;", ""], (0, _whenModern.whenModern)((0, _styledComponents.css)(["font-family:", ";font-size:14px;font-weight:600;letter-spacing:-0.01em;"], (0, _Theme.val)("FontFamilyHeading"))));
var PanelIcon = (0, _styledComponents["default"])(_core.Icon).withConfig({
  displayName: "Panel__PanelIcon",
  componentId: "sc-1yri6o7-3"
})(["margin-right:0.5rem;"]);
var PanelBody = _styledComponents["default"].div.withConfig({
  displayName: "Panel__PanelBody",
  componentId: "sc-1yri6o7-4"
})(["padding:", ";", ""], (0, _Theme.val)("PanelPadding"), (0, _whenModern.whenModern)("padding: 16px;"));
var PanelCloseButton = _styledComponents["default"].button.withConfig({
  displayName: "Panel__PanelCloseButton",
  componentId: "sc-1yri6o7-5"
})(["background:transparent;background-color:transparent;background-image:none;border:none;outline:none;margin-left:auto;cursor:pointer;"]);

/**
 * A simple panel.
 */
function Panel(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    onClose = _ref.onClose,
    overlay = _ref.overlay,
    children = _ref.children,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var showHeader = icon || title || typeof onClose === "function";
  var content = /*#__PURE__*/_react["default"].createElement(PanelWrapper, extra, showHeader && /*#__PURE__*/_react["default"].createElement(PanelHeader, null, icon && /*#__PURE__*/_react["default"].createElement(PanelIcon, {
    icon: icon
  }), title && /*#__PURE__*/_react["default"].createElement(PanelTitle, null, title), typeof onClose === "function" ? /*#__PURE__*/_react["default"].createElement(PanelCloseButton, {
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.SMALL_CROSS
  })) : null), /*#__PURE__*/_react["default"].createElement(PanelBody, null, children));
  if (overlay) {
    return /*#__PURE__*/_react["default"].createElement(_core.Overlay, {
      isOpen: true,
      onClose: onClose,
      usePortal: false,
      enforceFocus: false
    }, content);
  }
  return content;
}